export const isProduction = process.env.NODE_ENV === "production";

const LOCALHOST_PORT = "58157";
export const BASE_URL = isProduction ? "https://partsfinder.clpstudio.ro" : `http://localhost:${LOCALHOST_PORT}`;
